import * as MFARegistration_en from './MFARegistration.en.js';
import * as MFARegistration_es from './MFARegistration.es.js';

const MFARegistrationTuple = [
  { type: 'MFARegistration', language: 'en', object: MFARegistration_en.default },
  { type: 'MFARegistration', language: 'es', object: MFARegistration_es.default },
];

export default MFARegistrationTuple;
